/* eslint-disable */

import services from 'services';

export default {
  list: async ({ commit }, { suppliers, id, token }) => {
    const res = await services.ProductsService.list(suppliers, id, token);
    commit('SET_LIST', res);
  },
  clear: async ({ commit })  => {
    commit('CLEAR_PRODUCT');
  }
};
